<template>
  <v-row>
    <v-col>
      <Draggable
          class="dragArea list-group"
          :group="{name: 'widget', pull: 'clone', put: false}"
          :list="value"
          :clone="clone"
          @start="$emit('start', $event)"
          @end="$emit('end', $event)"
      >
        <v-expansion-panels
            class="widget-item-group item-group mb-2"
            :key="key"
            v-for="(widget, key) in value"
        >
          <v-expansion-panel class="widget-item">
            <v-expansion-panel-header>
              <template v-slot:default="{ open }">
                <v-row no-gutters>
                  <v-col cols="4" class="d-flex align-center">
                    <v-icon size="20" class="widgets-icon mr-2">
                      mdi-drag-variant
                    </v-icon>
                    {{ widget.name }}
                  </v-col>
                  <v-col cols="4" class="d-flex align-center text--secondary">
                    <v-fade-transition leave-absolute>
                      <div v-if="open" key="0" class="text-body-2">
                        "{{ widget.widget }}"
                      </div>
                    </v-fade-transition>
                  </v-col>
                  <v-col cols="4" align="right">
                    <!-- <v-btn small dark color="blue darken-4" class="mr-5">
                                              <v-icon size="18" left>mdi-plus-circle</v-icon>
                                              Ekle
                                          </v-btn> -->
                    <div v-if="isDraggable" class="text-caption grey--text text--darken-2 mr-4">
                      Sürükle Bırak
                    </div>
                  </v-col>
                </v-row>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list>
                <v-list-item-subtitle
                    class="text-caption font-weight-medium mb-2"
                >
                  Aldığı değerler dizisi
                  <v-divider></v-divider>
                </v-list-item-subtitle>
                <v-row>
                  <v-col :key="key" v-for="(field, key) in widget.fields">
                    <v-list-item class="px-0">
                      <v-list-item-content class="py-0">
                        <v-list-item-title>
                          <v-icon left>mdi-focus-field-horizontal</v-icon>
                          <span class="text-overline">{{ field.name }}</span>
                          <span class="text-caption">({{ field.type }})</span>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                </v-row>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </Draggable>
    </v-col>
  </v-row>
</template>

<script>
import Draggable from "vuedraggable";

export default {
  name: "WidgetPreview",
  props: {
    value: Array,
    clone: Function,
    isDraggable: false,
    groupId: String,
  },
  components: {Draggable},
  computed: {
    options() {
      return {

      };
    }
  },
};
</script>

<style scoped></style>
